import { CarLightFogIcon } from './CarLightFogIcon';

/**
 * author: Michael Irigoyen
 * id 3DAC6713-744B-485F-A985-7E2A16F14D6A
 * name car-light-fog
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-light-fog.svg
 * tags
 * - Automotive 
 */
export const HeadLightFogIcon = CarLightFogIcon;
export default HeadLightFogIcon